import { Cell, colors, Grid, Heading, HFlow, Icon, Text, VFlow } from 'bold-ui'
import { InfoIcon } from 'components/InfoIcon'
import { Color } from 'csstype'
import { FonteIdadeGestacionalEnum } from 'graphql/types.generated'
import { formatDate } from 'util/date/formatDate'
import { ListagemGestantePuerperaPreNatalPuerperioModel } from 'view/acompanhamento/acompanhamento-condicao-saude/model/lista-tematica/model-gestantePuerpera'
import { RiscoGravidezTag } from 'view/atendimentos/detail/soap/pre-natal/components/RiscoGravidezTag'
import { formatIdadeGestacional } from 'view/atendimentos/detail/soap/pre-natal/util-preNatal'

export interface AcompanhamentoCondicaoSaudeGestantePuerperaInfoSectionProps {
  gestantePuerpera: ListagemGestantePuerperaPreNatalPuerperioModel
  iconColor?: Color
}

const ACOMPANHAMENTO_PRE_NATAL_TOOLTIP_TEXT =
  'Apenas consultas da gestação atual marcadas como pré-natal na seção Objetivo do SOAP'

export function AcompanhamentoCondicaoSaudeGestantePuerperaInfoSection({
  gestantePuerpera,
  iconColor,
}: Readonly<AcompanhamentoCondicaoSaudeGestantePuerperaInfoSectionProps>) {
  return (
    <Grid gap={1} gapVertical={1} alignItems='baseline'>
      <Cell size={12}>
        <HFlow hSpacing={0.25} alignItems='center'>
          <Icon icon='pregnant' size={1} color={iconColor} />
          <Heading level={4}>Acompanhamento de pré-natal</Heading>
          <InfoIcon icon='infoCircleFilled' text={ACOMPANHAMENTO_PRE_NATAL_TOOLTIP_TEXT} />
        </HFlow>
      </Cell>
      <Cell size={3}>
        <VFlow vSpacing={0.25}>
          <Text fontWeight='bold'>Risco gestacional</Text>
          <RiscoGravidezTag isAltoRisco={gestantePuerpera?.altoRiscoGestacional} />
        </VFlow>
      </Cell>
      <Cell size={9}>
        <VFlow vSpacing={0.25}>
          <Text fontWeight='bold'>DUM</Text>
          <Text>{formatDate(gestantePuerpera?.ultimaDum)}</Text>
        </VFlow>
      </Cell>
      <Cell size={3}>
        <VFlow vSpacing={0.25}>
          <HFlow>
            <Text fontWeight='bold'>IG (DUM)</Text>{' '}
            {gestantePuerpera?.fonteIdadeGestacional === FonteIdadeGestacionalEnum.DUM && (
              <Icon icon='checkCircleOutline' color={colors.purple.c60} size={1} />
            )}
          </HFlow>
          <Text>{formatIdadeGestacional(gestantePuerpera?.idadeGestacionalCronologicaEmDias) ?? '-'}</Text>
        </VFlow>
      </Cell>
      <Cell size={3}>
        <VFlow vSpacing={0.25}>
          <Text fontWeight='bold'>DPP (DUM)</Text>
          <Text>{formatDate(gestantePuerpera?.dppCronologica)}</Text>
        </VFlow>
      </Cell>
      <Cell size={3}>
        <VFlow vSpacing={0.25}>
          <HFlow alignItems='center' hSpacing={0.5}>
            <Text fontWeight='bold'>IG (ecografia obstétrica)</Text>
            {gestantePuerpera?.fonteIdadeGestacional === FonteIdadeGestacionalEnum.US && (
              <Icon icon='checkCircleOutline' color={colors.purple.c60} size={1} />
            )}
          </HFlow>
          <Text>{formatIdadeGestacional(gestantePuerpera?.idadeGestacionalEcograficaEmDias) ?? '-'}</Text>
        </VFlow>
      </Cell>
      <Cell size={3}>
        <VFlow vSpacing={0.25}>
          <Text fontWeight='bold'>DPP (ecografia obstétrica)</Text>
          <Text>{formatDate(gestantePuerpera?.dppEcografica)}</Text>
        </VFlow>
      </Cell>
      <Cell size={3}>
        <VFlow vSpacing={0.25}>
          <Text fontWeight='bold'>Consultas</Text>
          <Text>{gestantePuerpera?.atendimentosPreNatalPuerperio?.consultasPreNatalGestacao ?? 0}</Text>
        </VFlow>
      </Cell>
      <Cell size={3}>
        <VFlow vSpacing={0.25}>
          <Text fontWeight='bold'>Consultas até 12 semanas</Text>
          <Text>{gestantePuerpera?.atendimentosPreNatalPuerperio?.consultasPrimeirasDozeSemanas ?? 0}</Text>
        </VFlow>
      </Cell>
      <Cell size={3}>
        <VFlow vSpacing={0.25}>
          <Text fontWeight='bold'>Última consulta</Text>
          <Text>{formatDate(gestantePuerpera?.atendimentosPreNatalPuerperio?.dataUltimaConsultaPreNatal)}</Text>
        </VFlow>
      </Cell>
      <Cell size={3}>
        <VFlow vSpacing={0.25}>
          <Text fontWeight='bold'>Consultas odontológicas</Text>
          <Text>{gestantePuerpera?.atendimentosPreNatalPuerperio?.consultasOdontologicasGestacao ?? 0}</Text>
        </VFlow>
      </Cell>
    </Grid>
  )
}
